import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// Components
import Box from '../shared/atoms/Box';
import Heading from '../shared/atoms/Heading';
import ListingCard from '../annuaire/ListingCard';
import { AnnuaireFonts } from '../annuaire/designSystem';
import Tunnel from '../../annuaire/tunnel/Tunnel';
import { Encart } from '../../annuaire/tunnel/ui';
import { grouperHorsZone } from './groupesHorsZone';

/**
 * Le module de réparation quand l'adresse est hors de la zone Roulez Jeunesse
 * (porte d'entrée 2, validée par Clément le 22/09 :
 * `docs/designs/reparation-hors-zone-liste.md`).
 *
 * Pas de « notre service n'est pas disponible » : on montre qui peut réparer
 * le vélo à cette adresse, avec les cartes de l'annuaire. Un partenaire Fixer
 * Lite se réserve sur place, dans le tunnel de la fiche annuaire, avec
 * l'adresse déjà saisie.
 */

const Cartes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Section = styled(Box)`
  gap: 16px;
`;

export default function HorsZone({ shops }) {
  const { t } = useTranslation();
  const position = useSelector((state) => state.course.position);
  const [atelierRdv, setAtelierRdv] = useState(null);
  const { partenaires, itinerants, ateliers } = grouperHorsZone(shops);
  const domicile = [...partenaires, ...itinerants];

  return (
    <Section mt={7}>
      <AnnuaireFonts />
      {domicile.length > 0 ? (
        <>
          <Heading level={2}>{t('horszone.domicile.titre')}</Heading>
          <Cartes>
            {partenaires.map((shop) => (
              <ListingCard
                key={shop.id}
                shop={shop}
                partenaire
                empile
                onPrendreRendezVous={setAtelierRdv}
              />
            ))}
            {itinerants.map((shop) => (
              <ListingCard key={shop.id} shop={shop} empile />
            ))}
          </Cartes>
        </>
      ) : (
        <Encart style={{ fontSize: 15, marginBottom: 8 }}>
          <span aria-hidden="true">ⓘ</span>
          <span>
            <b>{t('horszone.personne.titre')}</b> {t('horszone.personne.texte')}
          </span>
        </Encart>
      )}
      {ateliers.length > 0 && (
        <>
          <Heading level={2} mt={domicile.length > 0 ? 6 : 0}>
            {t('horszone.ateliers.titre')}
          </Heading>
          <Cartes>
            {ateliers.map((shop) => (
              <ListingCard key={shop.id} shop={shop} empile />
            ))}
          </Cartes>
        </>
      )}
      {atelierRdv && (
        <Tunnel
          shop={atelierRdv}
          adresseInitiale={typeof position === 'string' ? position : ''}
          onFermer={() => setAtelierRdv(null)}
        />
      )}
    </Section>
  );
}
